import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=10464c82&scoped=true&"
import script from "./staff.vue?vue&type=script&lang=ts&"
export * from "./staff.vue?vue&type=script&lang=ts&"
import style0 from "./staff.vue?vue&type=style&index=0&id=10464c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10464c82",
  null
  
)

component.options.__file = "staff.vue"
export default component.exports